<script>
  export let handlers = {};

  const handleKeydown = ev => {
    const k = ev.key === ' ' ? 'Space' : ev.key;
    const h = handlers[k];
    if (h) {
      ev.preventDefault();
      h();
    } else {
      console.debug(`unhandled key: ${k} (${ev.keyCode})`);
    }
  };
</script>

<svelte:window on:keydown={handleKeydown}/>
